/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useContext, useEffect, useState } from "react";
import MapPropsContext from "../MapPropsContext";
import { getApiHost } from "../../../utils";
import Axios from "axios";
import { faCrosshairs } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { message } from "antd";

// 군사시설보호구역 법정동코드 5자리 모음 (아래 쿼리로 조회함)
//  select distinct substr(LEG_DNR_CD, 0 , 5) from CL_MASTER_GIS
//  WHERE SECURE_GB = 'N'
//  AND LEG_DNR_CD IS NOT NULL;
const SECUREZONE_SIGCODE_LIST = [
  //"41650", // 경기 포천시
  //"41480", // 경기 파주시
  //"41570", // 경기 김포시
  //"42780", // 강원 철원군
  //"42820", // 강원 고성군
  //"42790", // 강원 화천군
  //"28710", // 인천 강화군
  //"41285", // 경기 고양시 일산동구
  //"42800", // 강원 양구군
  //"41800", // 경기 연천군
  //"28720", // 인천 옹진군
  //"42810", // 강원 인제군
  //"4425033022", // 충청남도 계룡시 신도안면 정장리
  //"4425033023",  // 충청남도 계룡시 신도안면 부남리
];

message.config({
  top: 250,
  duration: 15,
  maxCount: 1,
});

const infoBySecureZone = () => {
  message.info({
    content: (
      <span style={{ fontSize: 15 }}>
        {" "}
        해당 지역은 군사시설보호구역으로 검색 불가능합니다.
      </span>
    ),
  });
};

export default function WidgetCurrentLocation({ style }) {
  const [address, setAddress] = useState();
  const [error, setError] = useState();

  const { viewState, setIsHideFilteredPointsLayer, visibleRadius } =
    useContext(MapPropsContext);

  const { latitude, longitude } = viewState;

  useEffect(() => {
    async function location() {
      setError(null);
      try {
        const url = getApiHost() + "/address/getEmdKorNm.json";
        const params = { lat: latitude, lon: longitude };
        const { data } = await Axios.get(url, { params });

        let { EMD_KOR_NM, SIG_CD } = data;

        if (EMD_KOR_NM === undefined) EMD_KOR_NM = " 식별되지 않는 지역입니다.";

        if (visibleRadius) {
          // eslint-disable-next-line array-callback-return
          SECUREZONE_SIGCODE_LIST.map((secureZone) => {
            if (secureZone === SIG_CD) {
              EMD_KOR_NM = " 군사시설보호구역으로 검색 불가능합니다.";
              setIsHideFilteredPointsLayer(true);
            }
          });

          if (EMD_KOR_NM !== " 군사시설보호구역으로 검색 불가능합니다.") {
            setIsHideFilteredPointsLayer(false);
            message.destroy();
          } else {
            infoBySecureZone();
          }
        }

        setAddress(EMD_KOR_NM);
      } catch (e) {
        setError(e);
        console.error(e);
      }
    }
    location();
  }, [latitude, longitude]);

  return (
    <div
      style={{ ...DEFAULT_STYLE, ...style }}
      className={"widget-current-location-r"}
    >
      <FontAwesomeIcon icon={faCrosshairs} /> 현재 위치 :
      {!error && !address && "현재 위치 로딩 중 ..."}
      {error && "오류가 발생했습니다."}
      {address}
      <div style={{ display: "none" }} className={"widget-current-lat-r"}>
        {latitude}
      </div>
      <div style={{ display: "none" }} className={"widget-current-lon-r"}>
        {longitude}
      </div>
    </div>
  );
}

const DEFAULT_STYLE = {
  pointerEvents: "none",
  color: "black",
};
